var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2287_206565",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.433 7.011L28.697 14.274L7.27499 35.696H0.0119934V28.433L21.433 7.011ZM28.416 0.828003L28.5805 0.835002C28.9636 0.867659 29.3388 1.01458 29.6512 1.2753L29.781 1.394L34.314 5.927L34.4269 6.04994C35.0293 6.76448 35.0313 7.80978 34.4332 8.52661L34.314 8.657L30.769 12.202L23.506 4.939L27.05 1.394C27.428 1.017 27.922 0.828003 28.416 0.828003Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2287_206565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.62001 39.328H38.512V-2.80402H-3.62001V39.328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fill-selector",
    clipRule: "evenodd",
    d: "M-9.43201 45.139H44.323V-8.61597H-9.43201V45.139Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.096f3071252790d93319bad590a1a11f.svg";
export { ForwardRef as ReactComponent };